import { defineComponent as _defineComponent } from 'vue'
import FeatureSectionSmallBannersItem from './FeatureSectionSmallBannersItem.vue';
import { type CategoryBannerSmallData } from '../../../../types';
import { AbContainer, AbSection } from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';

interface Props {
  id?: string;
  items: CategoryBannerSmallData[];
  spacing?: Spacing;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionSmallBanners',
  props: {
    id: null,
    items: null,
    spacing: null
  },
  setup(__props: any) {



const position = (index: number) => {
  return (index + 1) % 2 ? 1 : 2;
};

return { __sfc: true,position, FeatureSectionSmallBannersItem, AbContainer, AbSection }
}

})